import { has, pick } from 'lodash-es';
import { getQuery } from 'client/utils/location';
import { LEASE, PURCHASE, SPECIAL_LOCATION_PARAMS } from 'site-modules/shared/constants/car-buying';
import { getDigitalRetailAvailablePrograms } from 'site-modules/shared/utils/inventory-utils/get-digital-retail-available-programs';

/**
 * Gets page state based on query param.
 * @param {Object} location
 * @param {boolean} isUsed
 * @param {object} vehicle
 * @returns {{isPurchase: boolean}}
 */
export function getDigitalRetailPageState(location, isUsed, vehicle) {
  const query = getQuery(location);

  const isPurchaseState = has(query, PURCHASE);
  const isLease = has(query, LEASE);
  const { loanProgram } = getDigitalRetailAvailablePrograms(vehicle);

  return {
    isPurchase: !!loanProgram && (isPurchaseState || !isLease || isUsed),
  };
}

/**
 * Gets special location params.
 * @param {Object} location
 * @returns {object}
 */
export function getSpecialLocationParams(location) {
  return pick(getQuery(location), [SPECIAL_LOCATION_PARAMS.REDIRECTED, SPECIAL_LOCATION_PARAMS.FORCED_PAGE_NAME]);
}
